import last from 'lodash/last';
import { matchPath } from 'react-router-dom';

import { SearchArticlesItem } from '../../common/api/searchArticles';
import { AppRoutePatterns } from '../../react-router';
import { BlockId, SolutionInfoParameters } from './helpCenter';

export const locationToSolutionInfo = (
  pathname: string,
  query: string,
  articles: SearchArticlesItem[],
): SolutionInfoParameters => {
  const searchParams = new URLSearchParams(query);

  if (matchPath(AppRoutePatterns.Categories, pathname)) {
    return {
      blockId: BlockId.AllHelpTopics,
      articleData: null,
    };
  }

  if (
    matchPath(AppRoutePatterns.CategoryById, pathname) ||
    matchPath(AppRoutePatterns.CategoryByUri, pathname)
  ) {
    return {
      blockId: BlockId.SubCategory,
      articleData: null,
    };
  }

  if (matchPath(AppRoutePatterns.Search, pathname)) {
    return {
      blockId: BlockId.SearchResults,
      articleData: articles,
      text: searchParams.get('query') ?? undefined,
    };
  }

  if (
    matchPath(AppRoutePatterns.ArticleById, pathname) ||
    matchPath(AppRoutePatterns.ArticleByUri, pathname)
  ) {
    return {
      blockId: BlockId.SingleArticle,
      articleData: last(pathname.split('/')) ?? null,
    };
  }

  return {
    blockId: BlockId.Homepage,
    articleData: null,
  };
};
